import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { FiCheckCircle } from "react-icons/fi";
import { getType } from "../../actions/studensts";
import UNAUTHORIZED from "../UNAUTHORIZED";
import StudentList from "../StudentList";

export default function Done() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { students } = useSelector((state) => state.students);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const count = useSelector((state) => state.students.count);
  const user = JSON.parse(localStorage.getItem("profile")).value[0].role;

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      if (search && search.trim() !== "") {
        dispatch(getType("done", "done", search));
      } else {
        dispatch(getType("done", "done", ""));
      }
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [location, search, dispatch]);

  useEffect(() => {
    if (students) setLoading(false);
    else setLoading(true);
  }, [students]);

  return (
    <div>
      {!["admin", "auditor", "agent"].includes(user) ? (        <UNAUTHORIZED />
      ) : (
        <div className="min-h-screen px-4 sm:px-8 py-6">
          {/* Page Header */}
          <div className="mb-8 flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl bg-emerald-600/20 border border-emerald-500/30 flex items-center justify-center shrink-0">
              <FiCheckCircle className="text-emerald-400 text-xl" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-white tracking-tight">Done Students</h1>
              <p className="text-slate-400 text-sm mt-0.5">Students who have completed all stages</p>
            </div>
          </div>

          {/* Content */}
          <div className="rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm p-6 shadow">
            <StudentList
              students={students}
              setSearch={setSearch}
              search={search}
              loading={loading}
              count={count}
            />
          </div>
        </div>
      )}
    </div>
  );
}
